webpackJsonp([70144966829960],{

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSvgInline = __webpack_require__(11);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SEO = __webpack_require__(12);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_React$Component) {
	  _inherits(Page, _React$Component);
	
	  function Page() {
	    _classCallCheck(this, Page);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Page.prototype.render = function render() {
	    var pageSEO = {
	      title: "Contact administrare imobile Bucuresti - Nicad Admin Imob",
	      description: "Contactati-ne pentru orice nelamuriri aveti in legatura cu administrarea imobilului dvs.",
	      path: "/contact/"
	    };
	    return _react2.default.createElement(
	      "div",
	      { className: "o-page__content" },
	      _react2.default.createElement(_SEO2.default, { pageSEO: pageSEO }),
	      _react2.default.createElement(
	        "div",
	        { className: "c-section-gradient" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container u-pv-20 u-pv-30@tablet u-text-center@tablet" },
	          _react2.default.createElement(
	            "h1",
	            { className: "c-page__heading" },
	            "Contact"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "o-container u-pv-20 u-pv-30@tablet" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-layout o-layout--gutter-20" },
	          _react2.default.createElement(
	            "div",
	            { className: "o-layout__item u-1/1 u-1/2@desktop" },
	            _react2.default.createElement(
	              "div",
	              { className: "c-contact__box" },
	              _react2.default.createElement(
	                "div",
	                { className: "o-layout" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "o-layout__item o-layout__item--auto-size" },
	                  _react2.default.createElement(_reactSvgInline2.default, {
	                    className: "u-mr-20",
	                    svg: "\n                      <svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                          <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n                              <g transform=\"translate(1.000000, 1.000000)\" stroke=\"#9CA7B6\" stroke-width=\"2\">\n                                  <path d=\"M20,14.92 L20,17.92 C20.0022858,18.4831451 19.767048,19.0211584 19.3520779,19.4018649 C18.9371078,19.7825714 18.3808639,19.9706881 17.82,19.92 C14.7428339,19.5856408 11.7869992,18.5341445 9.19,16.85 C6.77382812,15.3146639 4.72533615,13.2661719 3.19,10.85 C1.49997806,8.24120398 0.448243002,5.27099456 0.12,2.18 C0.0694732103,1.62087233 0.256272008,1.06625242 0.63476578,0.651621056 C1.01325955,0.236989688 1.54859424,0.000528690239 2.11,8.93924691e-17 L5.11,8.93924691e-17 C6.11386406,-0.00988015716 6.96950085,0.725967482 7.11,1.72 C7.23662301,2.68006645 7.47144946,3.62272688 7.81,4.53 C8.084735,5.26087503 7.90901507,6.08480626 7.36,6.64 L6.09,7.91 C7.51355547,10.4135458 9.58645417,12.4864445 12.09,13.91 L13.36,12.64 C13.9151937,12.0909849 14.739125,11.915265 15.47,12.19 C16.3772731,12.5285505 17.3199335,12.763377 18.28,12.89 C19.2855627,13.0318603 20.02519,13.9047926 20,14.92 Z\" id=\"Shape\"></path>\n                              </g>\n                          </g>\n                      </svg>" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "o-layout__item" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "c-label" },
	                    "telefon"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "u-mb-0 u-mt-05" },
	                    _react2.default.createElement(
	                      "a",
	                      { className: "c-link", href: "tel:+40753966211" },
	                      "0722 623 037"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "u-mb-0 u-mt-05" },
	                    _react2.default.createElement(
	                      "a",
	                      { className: "c-link", href: "tel:+40757484308" },
	                      "0757 484 308"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "o-layout__item u-1/1 u-1/2@desktop" },
	            _react2.default.createElement(
	              "div",
	              { className: "c-contact__box" },
	              _react2.default.createElement(
	                "div",
	                { className: "o-layout" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "o-layout__item o-layout__item--auto-size" },
	                  _react2.default.createElement(_reactSvgInline2.default, {
	                    className: "u-mr-20",
	                    svg: "\n                          <svg width=\"22px\" height=\"24px\" viewBox=\"0 0 18 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                              <desc>Created with Sketch.</desc>\n                              <defs></defs>\n                              <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n                                  <g id=\"noun_1153007_cc\" transform=\"translate(-17.000000, 1.000000)\" stroke=\"#9CA7B6\" stroke-width=\"2\" fill-rule=\"nonzero\">\n                                      <g id=\"Group\" transform=\"translate(18.000000, 0.000000)\">\n                                          <path d=\"M14.4993802,3.18389554 C12.9971167,1.19695321 10.5684575,0 7.96453429,0 C6.93798762,0 5.93647867,0.191512514 4.98504517,0.550598477 C2.88187638,1.36452666 1.27946207,2.92056583 0.503292635,4.95538629 C-0.272876798,6.94232862 -0.14768818,9.19260065 0.853820767,11.0837867 L6.03662957,20.8509249 C6.41219542,21.5690968 7.16332713,22 8.01460974,22 C8.84085462,22 9.61702405,21.5451578 9.9925899,20.8509249 L15.1753987,11.0837867 L15.1753987,11.0837867 L15.1753987,11.0837867 C16.4773603,8.52230686 16.2269831,5.4820457 14.4993802,3.18389554 Z\" id=\"Shape\"></path>\n                                          <path d=\"M7.98833819,4 C5.77259475,4 4,5.79591837 4,8.01166181 C4,10.2274052 5.79591837,12 7.98833819,12 C10.2040816,12 12,10.2040816 12,8.01166181 C11.9766764,5.79591837 10.2040816,4 7.98833819,4 Z\" id=\"Shape\"></path>\n                                      </g>\n                                  </g>\n                              </g>\n                          </svg>" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "o-layout__item" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "c-label" },
	                    "adresa"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "u-color-primary u-mb-0 u-mt-05" },
	                    "Bulevardul Basarabiei 76,",
	                    _react2.default.createElement("br", null),
	                    "sector 3, Bucuresti"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "o-layout__item u-1/1 u-1/2@desktop" },
	            _react2.default.createElement(
	              "div",
	              { className: "c-contact__box" },
	              _react2.default.createElement(
	                "div",
	                { className: "o-layout" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "o-layout__item o-layout__item--auto-size" },
	                  _react2.default.createElement(_reactSvgInline2.default, {
	                    className: "u-mr-20",
	                    svg: "\n                          <svg width=\"22px\" height=\"18px\" viewBox=\"0 0 22 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                            <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n                              <g transform=\"translate(1.000000, 1.000000)\" stroke=\"#9CA7B6\" stroke-width=\"2\">\n                                <path d=\"M2,0 L18,0 C19.1,0 20,0.9 20,2 L20,14 C20,15.1 19.1,16 18,16 L2,16 C0.9,16 0,15.1 0,14 L0,2 C0,0.9 0.9,0 2,0 Z\" id=\"Shape\"></path>\n                                <polyline points=\"20 2 10 9 0 2\"></polyline>\n                              </g>\n                            </g>\n                          </svg>" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "o-layout__item" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "c-label" },
	                    "email"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "u-mb-0 u-mt-05" },
	                    _react2.default.createElement(
	                      "a",
	                      { className: "c-link", href: "mailto:nicad.imob@gmail.com" },
	                      "nicad.imob@gmail.com"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "o-layout__item u-1/1 u-1/2@desktop" },
	            _react2.default.createElement(
	              "div",
	              { className: "c-contact__box" },
	              _react2.default.createElement(
	                "div",
	                { className: "o-layout" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "o-layout__item o-layout__item--auto-size" },
	                  _react2.default.createElement(_reactSvgInline2.default, {
	                    className: "u-mr-20",
	                    svg: "\n                          <svg width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                              <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n                                  <g transform=\"translate(1.000000, 1.000000)\" stroke=\"#9CA7B6\" stroke-width=\"2\">\n                                      <circle cx=\"10\" cy=\"10\" r=\"10\"></circle>\n                                      <polyline points=\"10 4 10 10 13 13\"></polyline>\n                                  </g>\n                              </g>\n                          </svg>" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "o-layout__item" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "c-label" },
	                    "program de lucru"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { className: "u-color-primary u-mb-0 u-mt-05" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "contact-days" },
	                      "Luni \u2013 Vineri:"
	                    ),
	                    " 09 \u2013 18",
	                    _react2.default.createElement("br", null)
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Page;
	}(_react2.default.Component);
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-faa78870013909e6ed86.js